import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { HttpEndpoint } from '../http/HttpEndpoint';
import { AssemblyIdRuntype } from '../idTypes';
import {
    CheckedBulkPnpItemsResponseRuntype,
    PnpBulkImportRequestRuntype,
    PnpBulkImportResponseRuntype,
    PnpFileInsertRuntype,
    PnpFileResponseRuntype,
    PnpFileRuntype,
    PnpItemRuntype,
    PnpUploadFailedURLResponseRuntype,
} from './pnpBackendTypes';

const invalidates: HttpEndpoint[] = [
    'GET /pnp/bulk/view',
    'POST /rfqs/:rfqId/customer-portal',
    'GET /assemblies/:assemblyId/state',
];

export const pnpEndpoints = {
    'GET /pnp': endpoint({
        description: 'Get a single PnP item',
        pathParams: z.undefined(),
        queryParams: z.object({
            id: z.string(),
        }),
        requestBody: z.undefined(),
        responseBody: PnpItemRuntype,
    }),

    'POST /pnp/upload-url': endpoint({
        description: 'Create a new PnP file and request a URL to upload it for parsing',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: PnpFileInsertRuntype,
        responseBody: PnpFileResponseRuntype,
    }),

    'POST /pnp/upload-failed-url': endpoint({
        description: 'Sets a PnP file to failed and request a URL to upload it for parsing',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: PnpFileInsertRuntype,
        responseBody: PnpUploadFailedURLResponseRuntype,
    }),

    'GET /pnp/file': endpoint({
        description: 'Get the details of PnP file for this asssembly, errors if not created',
        pathParams: z.undefined(),
        queryParams: z.object({
            assembly: AssemblyIdRuntype,
        }),
        requestBody: z.undefined(),
        responseBody: PnpFileRuntype,
    }),
    'DELETE /pnp/file': endpoint({
        description: 'Deletes a pnp file for a specific assembly',
        pathParams: z.undefined(),
        queryParams: z.object({
            assembly: AssemblyIdRuntype,
        }),
        requestBody: z.undefined(),
        responseBody: z.object({
            deleted: z.number(),
        }),
        invalidates,
    }),
    'POST /pnp/bulk/import': endpoint({
        description: 'Import Pick and Place items in bulk',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: PnpBulkImportRequestRuntype,
        responseBody: PnpBulkImportResponseRuntype,
        invalidates,
    }),
    'GET /pnp/bulk/view': endpoint({
        description: 'Gets all pnp items for a given assembly',
        pathParams: z.undefined(),
        queryParams: z.object({
            assembly: AssemblyIdRuntype,
        }),
        requestBody: z.undefined(),
        responseBody: CheckedBulkPnpItemsResponseRuntype,
    }),
};
